module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	fox.registerWidget('AmcSceneViewer', {
		getBannerSrc: function () {
			return fox._isNewFe ? require('../images/player_banner.png') : (fox.getEnv('design.url') + '/images/player_banner.png');
		}
	}, 'Content_VrSceneViewer');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/amcSceneViewer.js
// module id = 829
// module chunks = 4